import { createAction, props } from '@ngrx/store';
import { Balance, LoginCredentials, RegisterCredentials, User, UserHints, AIJob } from '../../models/auth.model';

// Initialize Auth
export const initAuth = createAction('[Auth] Initialize Auth');
export const noStoredToken = createAction('[Auth] No Stored Token');

// Get Current User
export const getCurrentUser = createAction('[Auth] Get Current User');
export const getCurrentUserSuccess = createAction(
  '[Auth] Get Current User Success',
  props<{ user: User }>()
);
export const getCurrentUserFailure = createAction(
  '[Auth] Get Current User Failure',
  props<{ error: string }>()
);

// Set User
export const setUser = createAction(
  '[Auth] Set User',
  props<{ user: User }>()
);

// User Hints
export const setUserHints = createAction(
  '[Auth] Set User Hints',
  props<{ userHints: UserHints }>()
);

export const getUserHints = createAction(
  '[Auth] Get User Hints'
);

// User balance
export const setUserBalance = createAction(
  '[Auth] Set User Balance',
  props<{ balance: Balance }>()
);

export const getUserBalance = createAction(
  '[Auth] Get User Balance'
);

// User AI Job
export const setUserAIJob = createAction(
  '[Auth] Set User AI Job',
  props<{ aiJob: AIJob | null }>()
);

export const getUserAIJob = createAction(
  '[Auth] Get User AI Job'
);

// Login
export const login = createAction(
  '[Auth] Login',
  props<{ credentials: LoginCredentials }>()
);
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{
    user: User;
    accessToken: string;
    refreshToken: string;
    socialRegistered: boolean;
    socialMerged: boolean;
    socialLogged: boolean;
  }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

// Register
export const register = createAction(
  '[Auth] Register',
  props<{ credentials: RegisterCredentials }>()
);
export const registerSuccess = createAction(
  '[Auth] Register Success',
  props<{ user: User; accessToken: string; refreshToken: string }>()
);
export const registerFailure = createAction(
  '[Auth] Register Failure',
  props<{ error: string }>()
);

export const clearAuthError = createAction('[Auth] Clear Error');

// Logout
export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');
